<template>
    <div class="page-jump" v-show="showPage">
        <span class="jump-span">跳至</span>
        <a class="jump-a" @click="changePage">{{pageNum}}</a>
    </div>
</template>
<script>
    export default {
        props:{
            showPage:{
                type: Boolean,
                default: false
            },
            pageNum:{
                type: Number,
                default: 5
            }
        },
        data(){
            return {

            }
        },
        mounted(){

        },
        computed:{

        },
        methods:{
            changePage(){
                this.$emit('pageJump', this.pageNum);
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    .page-jump{
        position: relative;
        width: 100px;
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
        color: $c_989;
        .jump-span{
            margin-right:7px;
        }
        .jump-a{
            display: inline-block;
            vertical-align: middle;
            width:56px;
            height:32px;
            border: 1px solid $border_bfb;
            border-radius: 8px;
            line-height: 32px;
            cursor: pointer;
            &:hover{
                color: $c_989;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/middleware/page-jump.vue